'use client';

import {
  fairtradeDarkChipActiveClass,
  fairtradeDarkChipClass,
  fairtradeDarkChipInactiveClass,
} from '@/components/help-center/fairtrade/fairtrade-dark-panel';
import { cn } from '@/lib/utils';
import type {
  PriceActivityDirectionFilter,
  PriceActivityMetricFilter,
} from '@/lib/price-activity-types';

type PriceActivityFiltersProps = {
  direction: PriceActivityDirectionFilter;
  metric: PriceActivityMetricFilter;
  onDirectionChange: (next: PriceActivityDirectionFilter) => void;
  onMetricChange: (next: PriceActivityMetricFilter) => void;
};

export function PriceActivityFilters({
  direction,
  metric,
  onDirectionChange,
  onMetricChange,
}: PriceActivityFiltersProps) {
  return (
    <div className="space-y-2">
      <div className="-mx-1 flex gap-1.5 overflow-x-auto px-1 pb-0.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <FilterChip
          active={direction === 'all'}
          onClick={() => onDirectionChange('all')}
          label="Todas"
        />
        <FilterChip
          active={direction === 'up'}
          onClick={() => onDirectionChange('up')}
          label="↑ Aumentaram"
        />
        <FilterChip
          active={direction === 'down'}
          onClick={() => onDirectionChange('down')}
          label="↓ Diminuíram"
        />
      </div>
      <div className="-mx-1 flex gap-1.5 overflow-x-auto px-1 pb-0.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        <FilterChip
          active={metric === 'all'}
          onClick={() => onMetricChange('all')}
          label="Todas as métricas"
        />
        <FilterChip
          active={metric === 'xats'}
          onClick={() => onMetricChange('xats')}
          label="Xats"
        />
        <FilterChip
          active={metric === 'days'}
          onClick={() => onMetricChange('days')}
          label="Days"
        />
      </div>
    </div>
  );
}

function FilterChip({
  active,
  onClick,
  label,
}: {
  active: boolean;
  onClick: () => void;
  label: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        fairtradeDarkChipClass,
        'shrink-0 whitespace-nowrap',
        active ? fairtradeDarkChipActiveClass : fairtradeDarkChipInactiveClass
      )}
    >
      {label}
    </button>
  );
}
